module.exports = __webpack_public_path__ + "static/media/ic-calendar.f8224755.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-calendar.svg
// module id = 603
// module chunks = 14